<template>
 <div style="display: flex;justify-content: center">
  <el-menu  :router="false"   mode="horizontal" @select="handleSelect">

    <!-- 自定义导航项 -->
    <template v-if="circleInfo && circleInfo.enableCustomNav">
      <el-menu-item 
        v-for="(nav, index) in customNavList" 
        :key="index"
        :index="nav.url"
      >
        {{ nav.name }}
      </el-menu-item>
    </template>
    <!-- 固定导航项 -->
  </el-menu>
  <div class="line"></div>
 </div>
</template>
<script>
export default {
  data() {
    return {
      circleInfo: null,
      customNavList: [],
      isAdmin: false
    };
  },
  props: {
    circleId: {
      type: [String, Number],
      required: false
    }
  },
  created() {
    // 检查是否是管理员

    // 如果有圈子ID,加载圈子信息
    if (this.circleId) {
      this.loadCircleInfo()
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      // 处理外部链接
      if (key.startsWith('http')) {
        window.open(key, '_blank')
      }
    },
    // 加载圈子信息
    async loadCircleInfo() {
      try {
        const res = await this.$http2({
          url: `/klgeek/circle/${this.circleId}`,
          method: 'GET'
        })
        this.circleInfo = res.data
        this.isAdmin = this.userStore.userInfo.id==this.circleInfo.createBy
        if (this.circleInfo.enableCustomNav && this.circleInfo.navList) {
          this.customNavList = JSON.parse(this.circleInfo.navList)
        }
      } catch(e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.logo {
  width: 50px;
}

.el-menu {
  border-bottom: none;
  
  .el-menu-item {
    height: 50px;
    line-height: 50px;
    
    &:hover {
      background-color: #f5f7fa;
    }
    
    &.is-active {
      color: #409EFF;
      border-bottom: 2px solid #409EFF;
    }
  }
}
</style>